import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 *@description
 * Check that project
 * name is not empty
 * @return {any}
 * @function
 */
export const projectNameNotEmpty = function () {
  return function (control: AbstractControl): ValidationErrors | null {
    let invalid = false;
    const requiredAndNotEmpty = control.value.replace(/\s/g, '') !== '';
    if (!requiredAndNotEmpty) {
      invalid = true;
    }
    return invalid ? { isEmpty: true } : null;
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-save/form-validators/project-name-not-empty.ts